function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrosoftOffline = function SvgMicrosoftOffline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 248.29,
    rx: 243.13,
    ry: 245.51,
    style: {
      fill: "#f6f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.58,258.09c6.11,1.71,12.38,2.91,18.23,5.19,28.18,11,44,40.32,38.37,70.68-5.29,28.62-31.37,50.42-61,50.44q-144.25.15-288.5,0c-41.6-.07-76.94-33.33-79.71-74.5-2.88-42.59,26.77-79.9,68.39-86.07,2-.3,4-.7,6.56-1.15-7.32-30.16-3.06-58.26,14.82-83.7,12.88-18.31,30.29-30.53,51.65-37.38,40.73-13.08,96.89,3,120.58,56.49,32.11-12.48,62.24-9.27,88.07,14.29C415.71,195.77,421.86,225.23,412.58,258.09Z",
    style: {
      fill: "#7f7f7f",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.46,240.71c6.11,1.71,12.38,2.91,18.23,5.19,28.18,11,44,40.32,38.37,70.68-5.29,28.62-31.37,50.41-61,50.44q-144.24.15-288.49,0C68,367,32.66,333.69,29.88,292.52c-2.87-42.59,26.78-79.9,68.4-86.07,2-.3,4-.7,6.56-1.15-7.32-30.16-3.06-58.26,14.82-83.7,12.88-18.31,30.29-30.53,51.65-37.39,40.73-13.07,96.89,3,120.58,56.5C324,128.23,354.13,131.44,380,155,405.59,178.39,411.74,207.85,402.46,240.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,317.54a3.52,3.52,0,1,1-7,0v-15.1a3.52,3.52,0,0,1,7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,287.34V272.23a3.52,3.52,0,0,1,7,0v15.11a3.52,3.52,0,0,1-7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,226.92v-15.1a3.52,3.52,0,1,1,7,0v15.1a3.52,3.52,0,1,1-7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,196.72V181.61a3.52,3.52,0,0,1,7,0v15.11a3.52,3.52,0,0,1-7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,257.13V242a3.52,3.52,0,1,1,7,0v15.1a3.52,3.52,0,1,1-7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9,331.38a3.53,3.53,0,0,1-3.52,3.52H192a15.69,15.69,0,0,1-7.1-1.69,3.52,3.52,0,0,1,3.17-6.28,8.64,8.64,0,0,0,3.93.93h9.38A3.53,3.53,0,0,1,204.9,331.38Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,166.51v-2.18a15.79,15.79,0,0,1,8-13.71,3.49,3.49,0,0,1,4.79,1.31,3.52,3.52,0,0,1-1.3,4.79,8.75,8.75,0,0,0-4.43,7.61v2.18a3.52,3.52,0,0,1-7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,152.07a3.53,3.53,0,0,1,3.52-3.52h15.1a3.52,3.52,0,1,1,0,7h-15.1A3.53,3.53,0,0,1,197.27,152.07Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.11,331.38a3.53,3.53,0,0,1-3.52,3.52h-15.1a3.52,3.52,0,0,1,0-7h15.1A3.53,3.53,0,0,1,235.11,331.38Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.31,331.38a3.52,3.52,0,0,1-3.51,3.52H246.69a3.52,3.52,0,0,1,0-7H261.8A3.52,3.52,0,0,1,265.31,331.38Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.52,331.38A3.53,3.53,0,0,1,292,334.9H276.9a3.52,3.52,0,0,1,0-7H292A3.53,3.53,0,0,1,295.52,331.38Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,223.42v15.1a3.52,3.52,0,1,1-7,0v-15.1a3.52,3.52,0,1,1,7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,253.62v15.11a3.52,3.52,0,1,1-7,0V253.62a3.52,3.52,0,0,1,7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,314v5.11a15.8,15.8,0,0,1-5,11.47,3.49,3.49,0,0,1-2.42,1,3.52,3.52,0,0,1-2.41-6.08,8.63,8.63,0,0,0,2.75-6.35V314a3.52,3.52,0,1,1,7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,283.83v15.1a3.52,3.52,0,1,1-7,0v-15.1a3.52,3.52,0,0,1,7,0Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.62,152.07a3.53,3.53,0,0,1-3.52,3.52H231a3.52,3.52,0,1,1,0-7h15.1A3.53,3.53,0,0,1,249.62,152.07Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,190.75a3.59,3.59,0,0,1-.22,2.69,3.52,3.52,0,0,1-6.48-.54,16.13,16.13,0,0,1-.77-4.93V175.81a3.52,3.52,0,1,1,7,0V188A9,9,0,0,0,261.53,190.75Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,165.34a3.49,3.49,0,0,1-2.39-.94l-4.39-4.16-.17-.11a3.52,3.52,0,0,1-7-.41v-7.56a3.51,3.51,0,0,1,5.9-2.59l2,1.82a3.08,3.08,0,0,1,.73.52l7.77,7.34a3.52,3.52,0,0,1-2.41,6.09Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,200.7v7.61a3.52,3.52,0,1,1-7,0v-4.19h-4a3.52,3.52,0,0,1-1.08-6.86,3.48,3.48,0,0,1-.39-1.27,2.28,2.28,0,0,1,0-.26,3.46,3.46,0,0,1,.91-2.64,3.52,3.52,0,0,1,5-.2l5.56,5.13A3.53,3.53,0,0,1,313.63,200.7Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,200.6a3.53,3.53,0,0,1-3.52,3.52H270.36a3.52,3.52,0,0,1,0-7h16.09A3.52,3.52,0,0,1,290,200.6Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.12,181.15a3.53,3.53,0,0,1,.19,5,3.51,3.51,0,0,1-5,.19l-13.8-12.73a3.52,3.52,0,0,1-.21-5,3.53,3.53,0,0,1,5-.2Z",
    style: {
      fill: "#5e9aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,286.73H236.86a1.85,1.85,0,0,1-1.84-1.84V262.12a1.84,1.84,0,0,0-1.84-1.84h-9.72a1.85,1.85,0,0,1-1.3-3.15l21.48-21.47a1.83,1.83,0,0,1,2.6,0l21.48,21.47a1.85,1.85,0,0,1-1.3,3.15H256.7a1.84,1.84,0,0,0-1.84,1.84v22.77A1.85,1.85,0,0,1,253,286.73Z",
    style: {
      fill: "#5e9aff"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftOffline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft-offline.0dd4a047.svg";
export { ForwardRef as ReactComponent };